export const educationData = [
    {
        id: 1,
        institution: 'Mikroskil University, Medan - Indonesia',
        course: 'Information System',
        startYear: '2016',
        endYear: '2020'
    },
]